import {
  Box,
  Divider,
  Flex,
  Grid,
  GridItem,
  Select,
  Text,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { ProductItem } from './ProductItem'
import { Link, useParams } from 'react-router-dom'
import {
  useCategoryQuery,
  useProductListQuery,
} from 'common/api/domains/goods/goodsQuery'
import { ProductListSortType } from '../type'

export const ProductListMobile = () => {
  const { categoryId } = useParams<{ categoryId: string }>()
  const { data: products } = useProductListQuery(categoryId || '1')
  const { data: category } = useCategoryQuery(categoryId || '1')
  const [sortType, setSortType] = useState<ProductListSortType>(
    ProductListSortType.NAME_ASC,
  )
  if (!category) return null

  return (
    <Box w={'360px'}>
      <Text my={4} textAlign={'center'} fontSize={22} fontWeight={'bold'}>
        {category.name}
      </Text>
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        pl={2}
        pr={2}
      >
        <Text fontWeight={'bold'} fontSize={14}>
          БҮТЭЭГДЭХҮҮН {products?.length || 0} {/*상품검색결과*/}
        </Text>
        <Select
          w={'inherit'}
          size={'sm'}
          value={sortType}
          onChange={(e) =>
            setSortType(e.target.value as unknown as ProductListSortType)
          }
          variant={'unstyled'}
          textAlign={'center'}
        >
          <option value={ProductListSortType.NAME_ASC}>А-Б</option>{' '}
          {/*오름차순*/}
          <option value={ProductListSortType.NAME_DESC}>Б-А</option>{' '}
          {/*오름차순*/}
          <option value={ProductListSortType.PRICE_DESC}>ӨНДӨР ҮНЭ</option>{' '}
          {/*가격높은순*/}
          <option value={ProductListSortType.PRICE_ASC}>БАГА ҮНЭ</option>{' '}
          {/*가격낮은순*/}
        </Select>
      </Flex>
      <Divider my={4} mb={6} />
      <Grid
        templateColumns={'repeat(auto-fill, 163px)'}
        gap={4}
        justifyContent="center"
      >
        {products &&
          products
            .sort((a, b) => {
              switch (sortType) {
                case ProductListSortType.NAME_ASC:
                  return a.name.localeCompare(b.name)
                case ProductListSortType.NAME_DESC:
                  return b.name.localeCompare(a.name)
                case ProductListSortType.PRICE_ASC:
                  return a.price - b.price
                case ProductListSortType.PRICE_DESC:
                  return b.price - a.price
                default:
                  return 0
              }
            })
            .map((product, index) => (
              <GridItem key={index}>
                <Link to={`/goods/products/${product.id}`}>
                  <ProductItem product={product} />
                </Link>
              </GridItem>
            ))}
      </Grid>
    </Box>
  )
}
